var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuestIcon = function SvgGuestIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 12C19.7963 12 21.2839 13.4251 21.9026 15.0533C22.2885 16.069 21.4691 17.0025 20.5 17M17.4583 12C19.9984 12 21.3525 13.4117 21.9179 15.0333C22.2803 16.0726 21.3887 16.9979 20.333 17M9.5001 15C5.25441 15 3.1228 16.9345 2.34981 19.0383C1.96846 20.0763 2.89739 20.9986 4.00315 20.997L15.0031 20.9802C16.1065 20.9785 17.0324 20.057 16.6516 19.0215C15.8796 16.9225 13.7479 15 9.5001 15ZM13.0001 8C13.0001 10.2087 11.2088 12 9.0001 12C6.79137 12 5.0001 10.2087 5.0001 8C5.0001 5.79127 6.79137 4 9.0001 4C11.2088 4 13.0001 5.79127 13.0001 8ZM19.5001 6C19.5001 7.10437 18.6045 8 17.5001 8C16.3957 8 15.5001 7.10437 15.5001 6C15.5001 4.89563 16.3957 4 17.5001 4C18.6045 4 19.5001 4.89563 19.5001 6Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGuestIcon;